import { HomeOutlined } from '@mui/icons-material';
import { Box } from '@mui/material';

import { INav } from '@interfaces/routes';
import urls from '@routes/urls';

export const headerNav: INav[] = [
  {
    i18nTitle: 'headerNav.home',
    path: urls.home,
    icon: <HomeOutlined />,
  },
  {
    i18nTitle: 'headerNav.dietarySupplementInquiry',
    path: urls.inquiryDraft,
    icon: <Box component="img" src="/images/img-diet.svg" />,
  },
  {
    i18nTitle: 'headerNav.medicationStatusLookup',
    path: urls.medications,
    icon: <Box component="img" src="/images/img-medicine.svg" />,
  },
];

export const headerAdditionalNav: INav[] = [
  {
    i18nTitle: 'headerAdditionalNav.disclaimer',
    path: process.env.REACT_APP_AXIS_PDF_DISCLAIMER || '',
  },
];

export const headerProfileNav: INav[] = [
  {
    i18nTitle: 'headerProfileNav.inquiries',
    path: urls.inquiries,
  },
];
